

































































































import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import User from '@/domain/user/user.entity';
import ProjectsDetail from '@/domain/project/project-detail.entity';
import ProjectUserStore from '@/domain/project/project-with-members.store';
import ProjectCardComponent from '@/views/project/project-card.component.vue';
import ProjectMembersListComponent from '@/views/project/project-members-list.component.vue';
import ProjectRulesComponent from '@/views/project/project-rules.component.vue';
import CustomFieldComponent from '@/views/project/project-custom-field.component.vue';
import ProjectDirectiveLink from '@/domain/project/project-directive-link.entity';
import ProjectModal from '@/views/project/project-modal.component.vue';
import DirectiveLinks from './directive-links.json';
import ProjectSearchService from '../../domain/project/project-search.service';
import ProjectPersist from '../../domain/project/project-persist.entity';

Component.registerHooks(['beforeRouteUpdate']);
@Component({
  components: {
    'project-card-component': ProjectCardComponent,
    'project-members-list-component': ProjectMembersListComponent,
    'project-rules-component': ProjectRulesComponent,
    'project-modal-component': ProjectModal,
    'custom-field-component': CustomFieldComponent,
  },
})
export default class ProjectComponent extends Vue {
  private projectsStore: ProjectUserStore = getModule(ProjectUserStore);

  private directivesComponentName: string = 'directives';

  private directiveLinks: ProjectDirectiveLink[] = DirectiveLinks;

  private dialog: boolean = false;

  private project: ProjectPersist = new ProjectPersist();

  private projectModalKey: number = 0;

  private get isTheDirectiveLinkListBigEnough(): boolean {
    return this.directiveLinks.length > 5;
  }

  private setProject(projectName: string): void {
    this.projectsStore.getProject(projectName)
      .then((projectDetail: ProjectsDetail) => ProjectSearchService
        .getOneProject(projectDetail.id)
        .then((value: ProjectsDetail) => {
          this.project = new ProjectPersist({
            id: value.id,
            name: value.name,
            description: value.description,
            projectUsers: value.members.map(member => member.user),
            members: value.members,
            allowMandalaEditClosedVsts: value.allowMandalaEditClosedVsts,
          });
        }));
  }

  private navigate(path: any): void {
    if (path.length > 0 && path !== '/') this.$router.push(`/${this.$route.params.projectName}/${path}`);
  }

  private editProject(): void {
    this.rerenderProjectModal();
    this.openModal();
  }

  private close(): void {
    this.closeModal();
  }

  private refresh(project: ProjectPersist): void {
    this.project = project;
    this.projectsStore.fetchProjects();
  }

  private openModal(): void {
    this.dialog = true;
  }

  private closeModal(): void {
    this.dialog = false;
  }

  private rerenderProjectModal(): void {
    this.projectModalKey += 1;
  }

  beforeRouteUpdate(to: any, from: any, next: any) {
    this.setProject(to.params.projectName);
    next();
  }

  created() {
    this.projectsStore.fetchProjects().then(() => this.setProject(this.$route.params.projectName));
  }
}
